export default __webpack_public_path__ + "static/media/Hand_right.d390ed92.svg";